import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { MdSnackBar } from '@angular/material';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    public snackbar:  MdSnackBar,
    private auth:     AuthService,
    private router:   Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return Observable.create(observer => {
        this.auth.authenticated().subscribe((auth) => {
          if (auth) {
            observer.next(true);
          } else {
            console.log('access denied');
            this.displayLoginInfo();
            this.router.navigate(['/login']);
            observer.next(false);
          }
        });
      });
    }

  private displayLoginInfo(): void {
    this.snackbar.open('You need to logged in as a super user to view this page.', '', {
      duration: 2000
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/auth.guard.ts